export const DATE_FORMAT: string = 'yyyy-MM-dd HH:mm:ss';
export const INSTANT_FORMAT: string = "yyyy-MM-dd'T'HH:mm:ss.SSSSSSX";